import {
  BILLING_CONTACT_FIELD_ERRORS,
  invitationPrefillFrom,
} from 'components/billingContacts/billingContactForm';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';

// Shared by the three billing contact modals (JBWEB-1285).

// The member route (1306) names its refusals differently from the contact
// routes; both land under the boxes.
const MEMBER_NOTIFICATION_ERRORS = {
  NOTIFICATION_TYPE_INVALID: ['notifications', 'notificationsInvalid'],
  NOTIFICATION_LEVEL_INVALID: ['notifications', 'notificationsInvalid'],
};

// The thing the modal is about is gone: nothing left to edit, the card reads
// the list again.
const GONE_ERRORS = {
  BILLING_CONTACT_NOT_FOUND: 'contactNotFound',
  MEMBER_NOT_FOUND: 'memberNotFound',
  COMPANY_NOT_FOUND: 'companyNotFound',
};

/**
 * How a modal answers a refusal: `canceled` (nothing), `field` (under
 * `field`), `gone` (message, then close) or `generic` (toast, the input kept).
 * `key` is under companyBillingContacts.errors.
 */
export const readBillingContactError = (error) => {
  if (error?.name === 'CanceledError') return { kind: 'canceled' };
  const code = error?.response?.data?.errorCode;
  const fieldError =
    BILLING_CONTACT_FIELD_ERRORS[code] ?? MEMBER_NOTIFICATION_ERRORS[code];
  if (fieldError) {
    return { kind: 'field', field: fieldError[0], key: fieldError[1] };
  }
  if (GONE_ERRORS[code]) return { kind: 'gone', key: GONE_ERRORS[code] };
  return { kind: 'generic', key: 'generic' };
};

/**
 * « Inviter sur Jobbiz »: the invitation modal (1262) takes the place of this
 * one, prefilled with what the admin typed. The Admin shows one modal at a
 * time, so this one is replaced, not stacked. `extra` goes with it
 * (companyContactId: the company's contact the new account is linked to).
 */
export const useInviteOnJobbiz = () => {
  const { setModalData } = UseContext();
  const { switchModal } = useModal();
  return (idCompany, form, extra = {}) => {
    setModalData({ idCompany, prefill: invitationPrefillFrom(form), ...extra });
    switchModal('add_company_member');
  };
};
